import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React, { Component } from 'react';
import { format } from 'date-fns';
export default class Chart_garmin_stress extends Component {
    constructor(props) {
        super(props);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.data !== this.props.data) {
            this.componentDidMount();
        }
    }
    componentDidMount() {
        var ctx = document.getElementById('Chart_garmin_stress').getContext('2d');
        const avg_data = this.props.data[7]['value'];
        const rest_data = this.props.data[10]['value'];
        const act_data = this.props.data[11]['value'];
        const low_data = this.props.data[12]['value'];
        const medium_data = this.props.data[13]['value'];
        const high_data = this.props.data[14]['value'];
        const date = this.props.data[7]['time'];
        var x_avg = [];
        var x_rest = [];
        var x_act = [];
        var x_low = [];
        var x_medium = [];
        var x_high = [];
        var y_data = [];
        for (var i = 0; i < avg_data.length; i++) {
            x_avg.push(avg_data[i]);
            x_rest.push(rest_data[i]);
            x_act.push(act_data[i]);
            x_low.push(low_data[i]);
            x_medium.push(medium_data[i]);
            x_high.push(high_data[i]);
            var tmp = format(new Date(date[i]), "yyyy/MM/dd");
            y_data.push(tmp);
        }
        var isstepped = false;
        if (window.Chart_garmin_stress instanceof Chart) window.Chart_garmin_stress.destroy();
        window.Chart_garmin_stress = new Chart(ctx, {
            type: "bar",
            // plugins: [ChartDataLabels],
            data: {
                //Bring in data
                labels: y_data,
                datasets: [
                    {
                        label: 'Avg. Stress',
                        data: x_avg,
                        yAxisID: 'stress_line',
                        stack: 'Stack 1',
                        steppedLine: isstepped,
                        backgroundColor: '#f7e514',
                        fill: false,
                        barPercentage: '0.7',
                        datalabels: {
                            // anchor: 'end',
                            // align: 'top',
                            // formatter: Math.round,
                            // font: {
                            //     weight: 'bold'
                            // }
                            display: false
                        }
                    },
                    {
                        label: 'Rest (seconds)',
                        data: x_rest,
                        yAxisID: 'stress_bar',
                        stack: 'Stack 0',
                        backgroundColor: '#fb9800',
                        barPercentage: '0.7',
                        datalabels: {
                            // color: '#000000',
                            // anchor: 'center',
                            // align: 'center',
                            // formatter: Math.round,
                            // font: {
                            //     weight: 'bold'
                            // }
                            display: false
                        }
                    },
                    {
                        label: 'Act (seconds)',
                        data: x_act,
                        yAxisID: 'stress_bar',
                        stack: 'Stack 0',
                        backgroundColor: '	#002bff',
                        barPercentage: '0.7',
                        datalabels: {
                            // color: '#000000',
                            // anchor: 'center',
                            // align: 'center',
                            // formatter: Math.round,
                            // font: {
                            //     weight: 'bold'
                            // }
                            display: false
                        }
                    },
                    {
                        label: 'Low (seconds)',
                        data: x_low,
                        yAxisID: 'stress_bar',
                        stack: 'Stack 0',
                        backgroundColor: '#A0ADA8',
                        barPercentage: '0.7',
                        datalabels: {
                            // color: '#000000',
                            // anchor: 'center',
                            // align: 'center',
                            // formatter: Math.round,
                            // font: {
                            //     weight: 'bold'
                            // }
                            display: false
                        }
                    },
                    {
                        label: 'Medium (seconds)',
                        data: x_medium,
                        yAxisID: 'stress_bar',
                        stack: 'Stack 0',
                        backgroundColor: '#E89DB5',
                        barPercentage: '0.7',
                        datalabels: {
                            // color: '#000000',
                            // anchor: 'center',
                            // align: 'center',
                            // formatter: Math.round,
                            // font: {
                            //     weight: 'bold'
                            // }
                            display: false
                        }
                    },
                    {
                        label: 'High (seconds)',
                        data: x_high,
                        yAxisID: 'stress_bar',
                        stack: 'Stack 0',
                        backgroundColor: '#ee0000',
                        barPercentage: '0.7',
                        datalabels: {
                            // color: '#000000',
                            // anchor: 'center',
                            // align: 'center',
                            // formatter: Math.round,
                            // font: {
                            //     weight: 'bold'
                            // }
                            display: false
                        }
                    },
                ]
            },
            options: {
                //Customize chart options
                responsive: true,
                title: {
                    display: true,
                    text: "Stress",
                    fontSize: 30,
                    fontFamily: 'Noto Sans CJK TC'
                },
                scales: {
                    // adapters: {
                    //     date: {
                    //         locale: 'zh-TW'
                    //     }
                    // },
                    xAxes: [
                        {
                            type: 'time',
                            display: true,
                            stacked: true,
                            offset: true,
                            time: {
                                unit: 'day'
                            }
                        }
                    ],
                    yAxes: [
                        {
                            type: 'linear',
                            display: true,
                            stacked: true,
                            position: 'left',
                            id: 'stress_line'
                        },
                        {
                            type: 'linear',
                            display: true,
                            stacked: true,
                            position: 'right',
                            id: 'stress_bar'
                        }
                    ]
                },
            }
        });
    }
    render() {
        return (
            <div>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.9.4/Chart.js"></script>
                <canvas id="Chart_garmin_stress"></canvas>
            </div>
        );
    }
}